import { render, staticRenderFns } from "./TxItems.vue?vue&type=template&id=333b6614&scoped=true&"
import script from "./TxItems.vue?vue&type=script&lang=js&"
export * from "./TxItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b6614",
  null
  
)

export default component.exports